export default __webpack_public_path__ + "static/media/8943.6aff1bc0.svg";